import { useMutation, useQueryClient } from '@tanstack/react-query';
import { makeRequest } from 'features/entry-form-v2/data/makeRequest';
import { CodelistRecord } from '../domain/codelistRecordSchema';

export const useUpdateCodelistForEntryMutation = (
	args: {
		originalEntryId: string;
		projectId: string;
	},
	opts?: {
		enabled?: boolean;
	}
) => {
	const queryClient = useQueryClient();

	const invalidateCodelist = () => {
		queryClient.invalidateQueries({
			queryKey: ['codelist', args.originalEntryId, args.projectId]
		});
	};

	return useMutation({
		mutationKey: ['codelist', args.originalEntryId, args.projectId],
		mutationFn: (record: CodelistRecord) =>
			makeRequest({
				method: 'updateCodelistForEntry',
				service: 'cde',
				data: {
					projectId: args.projectId,
					entryId: args.originalEntryId,
					record: {
						...record
					}
				}
			}),
		onSuccess: invalidateCodelist,

		retry: false,
		...opts
	});
};
